import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AuthUser, Role } from '@isoft-people/types';

interface AuthState {
  user: AuthUser | null;
  token: string | null;
  refreshToken: string | null;
  /** Cuando un ADMIN/HR activa "Vista colaborador", la UI se comporta como EMPLOYEE. */
  viewAsCollaborator: boolean;
  setSession: (user: AuthUser, token: string, refreshToken: string) => void;
  setViewAsCollaborator: (v: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      refreshToken: null,
      viewAsCollaborator: false,
      setSession: (user, token, refreshToken) =>
        set({ user, token, refreshToken, viewAsCollaborator: false }),
      setViewAsCollaborator: (v) => set({ viewAsCollaborator: v }),
      logout: () =>
        set({ user: null, token: null, refreshToken: null, viewAsCollaborator: false }),
    }),
    { name: 'isoft-people-auth' },
  ),
);

/**
 * Rol efectivo de la UI: si el usuario activó "Vista colaborador", se devuelve
 * EMPLOYEE aunque su rol real sea ADMIN/HR/MANAGER. Úsalo para nav y guards.
 */
export function useEffectiveRole(): Role | undefined {
  return useAuthStore((s) =>
    s.viewAsCollaborator && s.user ? ('EMPLOYEE' as Role) : (s.user?.role as Role | undefined),
  );
}
